import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Success = ({
  height = 16,
  width = 16,
  color = colors.green100,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      fill={getColor(color, isColorInherited)}
      fillRule="evenodd"
      d="M8 2.625a5.375 5.375 0 1 0 0 10.75 5.375 5.375 0 0 0 0-10.75Zm-4.685.69a6.625 6.625 0 1 1 9.37 9.37 6.625 6.625 0 0 1-9.37-9.37Zm7.048 2.676c.281.201.346.591.146.872l-2.5 3.5a.625.625 0 0 1-.95.079l-1.5-1.5a.625.625 0 1 1 .883-.884l.978.978 2.071-2.9c.201-.28.591-.345.872-.145Z"
      clipRule="evenodd"
    />
  </SvgIcon>
);
